import { useGoogleMaps } from "~/composables/Common/useGoogleMaps";

export default defineNuxtPlugin(async () => {
  const { loadGoogleMaps } = useGoogleMaps();

  await loadGoogleMaps();
});
